import { InputProps } from "../types/types";

const Input = ({
  type,
  className,
  placeholder,
  label,
  name,
  value,
  onChange,
  disabled,
  maxLength,
  ref,
}: InputProps) => {
  return (
    <div className="input-container-blk">
      <input
        type={type}
        className={className}
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={onChange}
        required
        aria-required="true"
        disabled={disabled}
        id={name}
        autoComplete="off"
        maxLength={maxLength}
        ref={ref}
      />
      {label && (
        <label htmlFor={name} className="label">
          {label}
          <span aria-hidden="true">*</span>
        </label>
      )}
    </div>
  );
};

export default Input;
